import Logo from "assets/img/logo";

export async function createDesktopNotification(title, body, timeout = 30, options) {
	if (!("Notification" in window)) {
		// eslint-disable-next-line no-alert
		alert("This browser does not support desktop notification");
	} else if (Notification.permission === "granted") {
		const notification = new Notification(title, {
			body,
			icon: Logo,
			...options,
		});

		setTimeout(notification.close.bind(notification), timeout * 1000);
	} else if (Notification.permission !== "denied") {
		Notification.requestPermission().then((permission) => {
			if (permission === "granted") {
				const notification = new Notification(title, {
					body,
					icon: Logo,
					...options,
				});

				setTimeout(notification.close.bind(notification), timeout * 1000);
			}
		});
	}
}
